import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as api from '../../api';
import { 
    fetchOverviewRequest, fetchOverviewSuccess, fetchUsersRequest, fetchUsersSuccess, 
    fetchDeletedRequest, fetchDeletedSuccess, fetchUserDetailsRequest, fetchUserDetailsSuccess,
    adminActionRequest, adminActionSuccess
} from '../slices/adminSlice';

// --- DATA FETCHING SAGAS ---
function* handleFetchOverview() {
    try {
        const [stats, lic, coup, price, loc] = yield all([
            call(api.getStats), call(api.getAllLicenses), call(api.getCoupons), call(api.getPricing), call(api.getLocations)
        ]);
        yield put(fetchOverviewSuccess({
            stats: stats.data, licenses: lic.data, coupons: coup.data, pricing: price.data, locations: loc.data
        }));
    } catch (e) { console.error(e); }
}

function* handleFetchUsers() {
    try { const res = yield call(api.adminGetUsers); yield put(fetchUsersSuccess(res.data)); } catch (e) {}
}

function* handleFetchDeleted() {
    try { const res = yield call(api.adminGetDeletedUsers); yield put(fetchDeletedSuccess(res.data)); } catch (e) {}
}

function* handleFetchUserDetails(action) {
    try { const res = yield call(api.adminGetUserDetails, action.payload); yield put(fetchUserDetailsSuccess(res.data)); } catch (e) {}
}

// --- GENERIC CRUD HANDLER ---
// action.payload looks like: { apiCall: function, params: obj, refreshAction: function, successMsg: string, emailForDetailsRefresh: string }
function* handleAdminAction(action) {
    const { apiCall, params, refreshAction, successMsg, emailForDetailsRefresh } = action.payload;
    try {
        yield call(apiCall, params);
        if(successMsg) alert(successMsg);
        yield put(adminActionSuccess());
        
        // Refresh the necessary tab
        if(refreshAction) yield put(refreshAction());
        // If an action updated a specific user's details, refresh that user's view
        if(emailForDetailsRefresh) yield put(fetchUserDetailsRequest(emailForDetailsRefresh));
        
    } catch (e) {
        alert(e.response?.data?.message || "Action failed");
        yield put(adminActionSuccess()); // Turn off loading
    }
}

export default function* adminSaga() {
  yield takeLatest(fetchOverviewRequest.type, handleFetchOverview);
  yield takeLatest(fetchUsersRequest.type, handleFetchUsers);
  yield takeLatest(fetchDeletedRequest.type, handleFetchDeleted);
  yield takeLatest(fetchUserDetailsRequest.type, handleFetchUserDetails);
  
  // Catches ALL CRUD requests dispatched from the UI
  yield takeLatest(adminActionRequest.type, handleAdminAction);
}